"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTag = exports.StyledLabel = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _templateObject;

var StyledTag = _styledComponents["default"].div.withConfig({
  displayName: "Tagstyles__StyledTag",
  componentId: "sc-p8lp0-0"
})(["display:inline-block;padding:0.125rem 0.5rem;box-shadow:0px 0px 10px rgba(28,40,51,0.1);border-radius:", ";", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.tag.borderRadius;
}, (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  "])), function (_ref2) {
  var _theme$tag$color, _theme$tag$color2;

  var color = _ref2.color,
      theme = _ref2.theme;
  return "".concat((_theme$tag$color = theme.tag[color]) === null || _theme$tag$color === void 0 ? void 0 : _theme$tag$color.appearance, " ").concat((_theme$tag$color2 = theme.tag[color]) === null || _theme$tag$color2 === void 0 ? void 0 : _theme$tag$color2.text);
}));

exports.StyledTag = StyledTag;

var StyledLabel = _styledComponents["default"].div.withConfig({
  displayName: "Tagstyles__StyledLabel",
  componentId: "sc-p8lp0-1"
})(["font-weight:700;font-size:0.75rem;line-height:1.25rem;"]);

exports.StyledLabel = StyledLabel;